export default __webpack_public_path__ + "static/media/todoist.85ea5f44.svg";